/* itg-product-tabs.js — SkyLabs Audio product detail tabs */
(function () {
  var SPEC_RE = /\b(specifications?|specs)\b/i;
  var QUOTE_OPEN_RE = /^["„«‟"']/;
  var QUOTE_CLOSE_RE = /["»'"']$/;

  var FLAT_BREAK_TAGS = new Set([
    "DIV",
    "TABLE",
    "DL",
    "UL",
    "OL",
    "FIGURE",
    "BLOCKQUOTE",
    "SECTION",
  ]);

  /* ── Utilities ──────────────────────────────────────────────────── */

  var stripInlineStyles = function (root) {
    if (root.hasAttribute && root.hasAttribute("style"))
      root.removeAttribute("style");
    root.querySelectorAll("[style]").forEach(function (n) {
      n.removeAttribute("style");
    });
    root.querySelectorAll("font").forEach(function (font) {
      var span = document.createElement("span");
      while (font.firstChild) span.appendChild(font.firstChild);
      font.replaceWith(span);
    });
  };

  var wrapStandaloneMedia = function (wrapper) {
    wrapper.querySelectorAll(":scope > iframe").forEach(function (el) {
      var wrap = document.createElement("div");
      wrap.className = "itg-embed-wrap";
      el.replaceWith(wrap);
      wrap.appendChild(el);
    });
    wrapper.querySelectorAll(":scope > video").forEach(function (el) {
      var wrap = document.createElement("div");
      wrap.className = "itg-video-wrap";
      el.replaceWith(wrap);
      wrap.appendChild(el);
    });
    wrapper.querySelectorAll(":scope > p").forEach(function (p) {
      var iframe = p.querySelector("iframe");
      var video = p.querySelector("video");
      if (iframe && !p.textContent.trim()) {
        var wrap = document.createElement("div");
        wrap.className = "itg-embed-wrap";
        wrap.appendChild(iframe);
        p.replaceWith(wrap);
      } else if (video && !p.textContent.trim()) {
        var wrap2 = document.createElement("div");
        wrap2.className = "itg-video-wrap";
        wrap2.appendChild(video);
        p.replaceWith(wrap2);
      }
    });
  };

  /* ── Pull-quote builder ─────────────────────────────────────────── */

  var buildPullquote = function (el) {
    var raw = el.textContent.trim();
    var text = raw
      .replace(/^["„«‟"'']+/, "")
      .replace(/["»"'']+$/, "")
      .trim();
    if (!text) return;

    var wrapper = document.createElement("div");
    wrapper.className = "itg-pullquote";

    var open = document.createElement("span");
    open.className = "itg-pullquote__mark";
    open.setAttribute("aria-hidden", "true");
    open.textContent = "“";

    var p = document.createElement("p");
    p.className = "itg-pullquote__text";
    p.textContent = text;

    var close = document.createElement("span");
    close.className = "itg-pullquote__mark itg-pullquote__mark--close";
    close.setAttribute("aria-hidden", "true");
    close.textContent = "”";

    wrapper.append(open, p, close);
    el.replaceWith(wrapper);
  };

  var isQuoteBlock = function (el) {
    if (el.tagName === "BLOCKQUOTE") return true;
    if (el.querySelector("img, table, dl, ul, ol")) return false;
    var visibleKids = Array.from(el.children).filter(function (k) {
      return !k.hidden;
    });
    if (visibleKids.length === 1 && visibleKids[0].tagName === "P") {
      var t = visibleKids[0].textContent.trim();
      return QUOTE_OPEN_RE.test(t) && QUOTE_CLOSE_RE.test(t) && t.length > 10;
    }
    if (visibleKids.length === 0) {
      var t2 = el.textContent.trim();
      return (
        QUOTE_OPEN_RE.test(t2) && QUOTE_CLOSE_RE.test(t2) && t2.length > 10
      );
    }
    return false;
  };

  /* ── Feature card builder ────────────────────────────────────────── */

  var buildFeatureCard = function (div) {
    if (div.hidden) return false;
    if (div.querySelector(":scope > table, :scope > dl")) return false;

    // If this div has multiple headings it's a wrapper, not a single feature card
    // Exception: allow when any heading embeds an image (e.g. Eversolo-style h3+img)
    var directHeadings = div.querySelectorAll(
      ":scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6",
    );
    var anyHeadingHasImage = Array.from(directHeadings).some(function (h) {
      return !!h.querySelector("img, video, iframe");
    });
    if (directHeadings.length > 1 && !anyHeadingHasImage) return false;

    var heading = div.querySelector(
      ":scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6",
    );
    if (!heading) return false;
    if (SPEC_RE.test(heading.textContent.trim())) return false;

    var paragraphs = Array.from(div.querySelectorAll(":scope > p"));
    // Paragraphs may be wrapped one level deep in a plain content div
    if (!paragraphs.length) {
      var innerWrap = div.querySelector(":scope > div:not([class])");
      if (
        innerWrap &&
        !innerWrap.querySelector(
          ":scope > h2,:scope > h3,:scope > h4,:scope > h5,:scope > h6",
        )
      ) {
        paragraphs = Array.from(innerWrap.querySelectorAll(":scope > p"));
      }
    }
    var hasContent =
      paragraphs.length > 0 ||
      !!div.querySelector(
        ":scope > ul, :scope > ol, :scope > div > ul, :scope > div > ol",
      ) ||
      (function () {
        var d = div.querySelector(":scope > div:not([class])");
        return !!(d && d.textContent.trim());
      })();
    if (!hasContent && !anyHeadingHasImage) return false;

    var imgNode = null;
    var imgSourceP = null;

    var directImg = div.querySelector(":scope > img");
    var directFigure = div.querySelector(":scope > figure");
    var directVideo = div.querySelector(":scope > video");
    var directIframe = div.querySelector(":scope > iframe");

    if (directImg) {
      imgNode = directImg;
    } else if (directFigure) {
      imgNode = directFigure;
    } else if (directVideo) {
      imgNode = directVideo;
    } else if (directIframe) {
      imgNode = directIframe;
    } else {
      for (var i = 0; i < paragraphs.length; i++) {
        var inner = paragraphs[i].querySelector("img, video, iframe");
        if (inner) {
          imgNode = inner;
          imgSourceP = paragraphs[i];
          break;
        }
      }
    }

    /* Fallback: image embedded inside any heading element */
    if (!imgNode) {
      Array.from(directHeadings).some(function (h) {
        var headingMedia = h.querySelector("img, video, iframe");
        if (headingMedia) {
          imgNode = headingMedia;
          return true;
        }
        return false;
      });
    }

    div.classList.add("product-feature");

    if (imgNode) {
      var mediaSource = imgNode.closest("figure") || imgNode;
      mediaSource.remove();

      if (imgSourceP) {
        imgSourceP.querySelectorAll("b, strong, span").forEach(function (el) {
          if (!el.textContent.trim()) el.remove();
        });
        if (!imgSourceP.textContent.trim() && !imgSourceP.children.length) {
          imgSourceP.remove();
        }
      }

      var media = document.createElement("div");
      media.className = "product-feature__media";

      if (imgNode.tagName === "IFRAME") {
        var embedWrap = document.createElement("div");
        embedWrap.className = "itg-embed-wrap";
        embedWrap.appendChild(mediaSource);
        media.appendChild(embedWrap);
      } else if (imgNode.tagName === "VIDEO") {
        var videoWrap = document.createElement("div");
        videoWrap.className = "itg-video-wrap";
        videoWrap.appendChild(mediaSource);
        media.appendChild(videoWrap);
      } else {
        media.appendChild(mediaSource);
      }

      var content = document.createElement("div");
      content.className = "product-feature__content";
      while (div.firstChild) content.appendChild(div.firstChild);
      div.append(media, content);

      /* Long paragraphs stay in the content column; buildTechMagazine trims
       * to 250 words and places the remainder below the card. */
    } else {
      div.classList.add("product-feature--text");
      var allParas = Array.from(div.querySelectorAll(":scope > p"));
      if (allParas.length > 1) {
        var splitAt = Math.min(2, allParas.length);
        var overflowParas = allParas.slice(splitAt);
        if (overflowParas.length) {
          var overflow2 = document.createElement("div");
          overflow2.className = "product-feature__overflow";
          overflowParas.forEach(function (p) {
            overflow2.appendChild(p);
          });
          div.classList.add("has-overflow");
          div.after(overflow2);
        }
      }
    }

    return true;
  };

  /* ── Spec-div detection ──────────────────────────────────────────── */

  var isLabelRow = function (row) {
    // Pattern 1: <strong>Label:</strong> or <b>Label:</b>
    var s = row.querySelector(":scope > strong, :scope > b");
    if (s && s.textContent.trim().endsWith(":")) return true;
    var kids = Array.from(row.children);
    // Pattern 2: <span>Label</span><div>Value</div>
    if (
      kids.length === 2 &&
      kids[0].tagName === "SPAN" &&
      kids[1].tagName === "DIV" &&
      !!kids[0].textContent.trim()
    )
      return true;
    // Pattern 3: <div>Label</div><div>Value</div> (plain text div pairs, no nested elements)
    if (
      kids.length === 2 &&
      kids[0].tagName === "DIV" &&
      kids[1].tagName === "DIV" &&
      !kids[0].children.length &&
      !!kids[0].textContent.trim()
    )
      return true;
    // Pattern 4: <div><p>Label</p><p>Value</p></div> (plain text paragraph pairs)
    if (
      kids.length === 2 &&
      kids[0].tagName === "P" &&
      kids[1].tagName === "P" &&
      !kids[0].children.length &&
      !!kids[0].textContent.trim()
    )
      return true;
    return false;
  };

  var isSpecDiv = function (el) {
    if (el.tagName !== "DIV") return false;
    if (el.querySelector("iframe, video")) return false;
    if (isLabelRow(el)) return true;
    var kids = el.children;
    if (kids.length < 2) return false;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].tagName !== "DIV" || !isLabelRow(kids[i])) return false;
    }
    return true;
  };

  /* ── Group flat heading+content into div wrappers ───────────────── */

  var groupFlatContent = function (descPanel) {
    // ── Pre-processing pass 1: peel single outer wrapper divs ────────
    // Runs up to 3 times to handle double-wrapped content like:
    //   wrapper1 → wrapper2 → [h2, p, feature-divs...]
    // Two conditions trigger a peel:
    //   a) the wrapper has direct H2-H6 heading children (original logic)
    //   b) the wrapper contains ONLY div children (pure structural wrapper —
    //      safe to inline since it adds no content of its own)
    var peelCount = 0;
    while (peelCount < 3) {
      var outerKids = Array.from(descPanel.children);
      if (
        outerKids.length !== 1 ||
        outerKids[0].tagName !== "DIV" ||
        outerKids[0].hidden
      )
        break;
      var singleWrap = outerKids[0];
      var innerKids = Array.from(singleWrap.children);
      var hasDirectHeadings = innerKids.some(function (k) {
        return /^H[2-6]$/.test(k.tagName);
      });
      var allChildrenAreDivs =
        innerKids.length > 0 &&
        innerKids.every(function (k) {
          return k.tagName === "DIV";
        });
      if (!hasDirectHeadings && !allChildrenAreDivs) break;
      while (singleWrap.firstChild)
        descPanel.insertBefore(singleWrap.firstChild, singleWrap);
      singleWrap.remove();
      peelCount++;
      if (hasDirectHeadings) break;
    }

    // ── Pre-processing pass 2: explode any div with multiple headings ──
    // Handles cases like <div><h2>Section</h2><h3>Feature1</h3>...<h3>Feature2</h3>...</div>
    // where several image-with-text sections are wrapped in one container div.
    // Runs up to 5 times to handle nested wrappers.
    var explodePass = function () {
      var changed = false;
      Array.from(descPanel.children).forEach(function (kid) {
        if (kid.tagName !== "DIV" || kid.hidden) return;
        var directHds = Array.from(kid.children).filter(function (c) {
          return /^H[2-6]$/.test(c.tagName);
        });
        if (directHds.length > 1) {
          while (kid.firstChild) descPanel.insertBefore(kid.firstChild, kid);
          kid.remove();
          changed = true;
        }
      });
      return changed;
    };
    var explodeCount = 0;
    while (explodePass() && ++explodeCount < 5) {}

    var children = Array.from(descPanel.children);
    var hasFlatHeadings = false;
    for (var i = 0; i < children.length; i++) {
      if (/^H[2-6]$/.test(children[i].tagName)) {
        hasFlatHeadings = true;
        break;
      }
    }
    if (!hasFlatHeadings) return;

    var newChildren = [];
    var currentDiv = null;
    var pendingMedia = null;

    for (i = 0; i < children.length; i++) {
      var child = children[i];
      var tag = child.tagName;

      if (/^H[2-6]$/.test(tag)) {
        currentDiv = document.createElement("div");
        if (pendingMedia) {
          currentDiv.appendChild(pendingMedia);
          pendingMedia = null;
        }
        currentDiv.appendChild(child);
        newChildren.push(currentDiv);
      } else if (FLAT_BREAK_TAGS.has(tag)) {
        // Keep figure/ul/ol grouped with the current heading card
        if (currentDiv && (tag === "FIGURE" || tag === "UL" || tag === "OL")) {
          currentDiv.appendChild(child);
        } else {
          if (pendingMedia) {
            newChildren.push(pendingMedia);
            pendingMedia = null;
          }
          currentDiv = null;
          newChildren.push(child);
        }
      } else if (
        !currentDiv &&
        (tag === "IMG" || tag === "IFRAME" || tag === "VIDEO")
      ) {
        if (pendingMedia) newChildren.push(pendingMedia);
        pendingMedia = child;
      } else if (currentDiv) {
        currentDiv.appendChild(child);
      } else {
        if (pendingMedia) {
          newChildren.push(pendingMedia);
          pendingMedia = null;
        }
        newChildren.push(child);
      }
    }

    if (pendingMedia) newChildren.push(pendingMedia);

    var frag = document.createDocumentFragment();
    for (var j = 0; j < newChildren.length; j++)
      frag.appendChild(newChildren[j]);
    while (descPanel.firstChild) descPanel.removeChild(descPanel.firstChild);
    descPanel.appendChild(frag);
  };

  /* ── Apply specs styles to a cloned element ─────────────────────── */

  var applySpecsStyles = function (el) {
    var tables =
      el.tagName === "TABLE" ? [el] : Array.from(el.querySelectorAll("table"));
    tables.forEach(function (tbl) {
      tbl.classList.add("itg-specs__table");
      tbl.querySelectorAll("tr").forEach(function (tr) {
        tr.classList.add("itg-specs__row");
      });
      tbl
        .querySelectorAll("tr > td:first-child, tr > th:first-child")
        .forEach(function (c) {
          c.classList.add("itg-specs__label");
        });
      tbl
        .querySelectorAll("tr > td:last-child, tr > th:last-child")
        .forEach(function (c) {
          c.classList.add("itg-specs__value");
        });
    });

    var dls =
      el.tagName === "DL" ? [el] : Array.from(el.querySelectorAll("dl"));
    dls.forEach(function (dl) {
      dl.classList.add("itg-specs__dl");
      dl.querySelectorAll("dt").forEach(function (dt) {
        dt.classList.add("itg-specs__dt");
      });
      dl.querySelectorAll("dd").forEach(function (dd) {
        dd.classList.add("itg-specs__dd");
      });
    });

    var labeledRows = [];
    el.querySelectorAll("div, p").forEach(function (row) {
      var strong = row.querySelector(":scope > strong, :scope > b");
      if (!strong || !strong.textContent.trim().endsWith(":")) return;
      var label = strong.textContent.replace(/:\s*$/, "").trim();
      var clone = row.cloneNode(true);
      clone.querySelectorAll("strong, b").forEach(function (s) {
        s.remove();
      });
      var value = clone.textContent.trim();
      if (!label || !value) return;
      labeledRows.push([label, value]);
      row.remove();
    });

    /* Pattern 2: <div><span>Label</span><div>Value</div></div> */
    el.querySelectorAll("div").forEach(function (row) {
      var kids = Array.from(row.children);
      if (
        kids.length !== 2 ||
        kids[0].tagName !== "SPAN" ||
        kids[1].tagName !== "DIV"
      )
        return;
      var label = kids[0].textContent.trim();
      var value = kids[1].textContent.trim();
      if (!label || !value) return;
      labeledRows.push([label, value]);
      row.remove();
    });

    /* Pattern 3: <div><div>Label</div><div>Value</div></div> — plain text div pairs */
    el.querySelectorAll("div").forEach(function (row) {
      var kids = Array.from(row.children);
      if (
        kids.length !== 2 ||
        kids[0].tagName !== "DIV" ||
        kids[1].tagName !== "DIV" ||
        kids[0].children.length > 0 ||
        kids[1].children.length > 0
      )
        return;
      var label = kids[0].textContent.trim();
      var value = kids[1].textContent.trim();
      if (!label || !value) return;
      labeledRows.push([label, value]);
      row.remove();
    });

    /* Pattern 4: <div><p>Label</p><p>Value</p></div> — plain text paragraph pairs */
    el.querySelectorAll("div").forEach(function (row) {
      var kids = Array.from(row.children);
      if (
        kids.length !== 2 ||
        kids[0].tagName !== "P" ||
        kids[1].tagName !== "P" ||
        kids[0].children.length > 0
      )
        return;
      var label = kids[0].textContent.trim();
      var value = kids[1].textContent.trim();
      if (!label || !value) return;
      labeledRows.push([label, value]);
      row.remove();
    });

    if (labeledRows.length) {
      var tbl = document.createElement("table");
      tbl.className = "itg-specs__table";
      var tbody = document.createElement("tbody");
      var frag = document.createDocumentFragment();
      labeledRows.forEach(function (pair) {
        var tr = document.createElement("tr");
        tr.className = "itg-specs__row";
        var tdL = document.createElement("td");
        tdL.className = "itg-specs__label";
        tdL.textContent = pair[0];
        var tdV = document.createElement("td");
        tdV.className = "itg-specs__value";
        tdV.textContent = pair[1];
        tr.append(tdL, tdV);
        frag.appendChild(tr);
      });
      tbody.appendChild(frag);
      tbl.appendChild(tbody);
      el.appendChild(tbl);
    }

    stripInlineStyles(el);

    el.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(function (h) {
      if (SPEC_RE.test(h.textContent.trim())) h.hidden = true;
    });

    el.querySelectorAll("div").forEach(function (d) {
      if (!d.textContent.trim() && !d.querySelector("img, table, ul, ol"))
        d.remove();
    });

    if (el.tagName !== "TABLE" && el.tagName !== "DL") {
      el.classList.add("itg-specs__block");
    }
  };

  /* ── Sync specs ──────────────────────────────────────────────────── */

  var syncSpecs = function (section) {
    var descPanel = section.querySelector('[data-tab-panel="description"]');
    var specsPanel = section.querySelector('[data-tab-panel="specifications"]');
    if (!descPanel || !specsPanel) return;

    var emptyMsg = specsPanel.querySelector("[data-itg-specs-empty]");
    var added = false;
    var clonedSources = new Set();

    var cloneToSpecs = function (el) {
      if (el.querySelector && el.querySelector("iframe, video")) return;
      clonedSources.add(el);
      var clone = el.cloneNode(true);
      applySpecsStyles(clone);
      specsPanel.insertBefore(clone, emptyMsg);
      added = true;
    };

    var alreadyCaptured = function (el) {
      if (clonedSources.has(el)) return true;
      for (var src of clonedSources) {
        if (src === el || src.contains(el)) return true;
      }
      return false;
    };

    var children = Array.from(descPanel.children);
    var rteWrapper =
      descPanel.querySelector(".itg-tabs__product-desc") || descPanel;

    descPanel.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(function (heading) {
      if (!SPEC_RE.test(heading.textContent.trim())) return;
      var container = heading.parentElement;
      if (!container || container === rteWrapper || container === descPanel)
        return;

      Array.from(container.querySelectorAll("table")).forEach(function (table) {
        if (alreadyCaptured(table)) return;
        cloneToSpecs(table);
        table.hidden = true;
      });
      Array.from(container.querySelectorAll("dl")).forEach(function (dl) {
        if (alreadyCaptured(dl)) return;
        cloneToSpecs(dl);
        dl.hidden = true;
      });
      /* Collect direct spec divs; batch multiple rows into one container so
       * applySpecsStyles builds a single table rather than many one-row tables. */
      var specDivBatch = [];
      Array.from(container.children).forEach(function (child) {
        if (child === heading || child.hidden || alreadyCaptured(child)) return;
        if (!isSpecDiv(child)) return;
        specDivBatch.push(child);
      });
      if (specDivBatch.length === 1) {
        cloneToSpecs(specDivBatch[0]);
        specDivBatch[0].hidden = true;
      } else if (specDivBatch.length > 1) {
        var batchWrap = document.createElement("div");
        specDivBatch.forEach(function (row) {
          clonedSources.add(row);
          batchWrap.appendChild(row.cloneNode(true));
          row.hidden = true;
        });
        applySpecsStyles(batchWrap);
        specsPanel.insertBefore(batchWrap, emptyMsg);
        added = true;
      }

      /* Handle sub-sections: <div><h4>Sub-heading</h4><div>spec-rows</div></div>
       * Each sub-section is cloned individually so its heading stays above its table. */
      Array.from(container.children).forEach(function (child) {
        if (child === heading || child.hidden || alreadyCaptured(child)) return;
        if (child.tagName !== "DIV") return;
        var childSubHd = child.querySelector(
          ":scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6",
        );
        if (!childSubHd) return;
        var hasSpec = Array.from(child.children).some(function (gc) {
          return (
            gc !== childSubHd &&
            !gc.hidden &&
            !alreadyCaptured(gc) &&
            isSpecDiv(gc)
          );
        });
        if (!hasSpec) return;
        clonedSources.add(child);
        var subClone = child.cloneNode(true);
        applySpecsStyles(subClone);
        specsPanel.insertBefore(subClone, emptyMsg);
        added = true;
        child.hidden = true;
      });
    });

    descPanel.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(function (h) {
      if (SPEC_RE.test(h.textContent.trim())) h.hidden = true;
    });

    descPanel.querySelectorAll("table").forEach(function (table) {
      if (alreadyCaptured(table)) return;
      cloneToSpecs(table);
      table.hidden = true;
      var par = table.parentElement;
      if (par && par !== descPanel && par !== rteWrapper) {
        if (
          Array.from(par.children).every(function (k) {
            return k.hidden;
          })
        ) {
          par.hidden = true;
        }
      }
    });

    descPanel.querySelectorAll("dl").forEach(function (dl) {
      if (alreadyCaptured(dl)) return;
      cloneToSpecs(dl);
      dl.hidden = true;
      var par = dl.parentElement;
      if (par && par !== descPanel && par !== rteWrapper) {
        if (
          Array.from(par.children).every(function (k) {
            return k.hidden;
          })
        ) {
          par.hidden = true;
        }
      }
    });

    children.forEach(function (el) {
      if (alreadyCaptured(el) || !isSpecDiv(el)) return;
      cloneToSpecs(el);
      el.hidden = true;
    });

    var extractTrailingLabelRows = function (container) {
      var kids = Array.from(container.children);
      var trailing = [];
      for (var i = kids.length - 1; i >= 0; i--) {
        var k = kids[i];
        if (k.hidden || alreadyCaptured(k)) break;
        if (k.tagName === "DIV" && isLabelRow(k)) trailing.unshift(k);
        else break;
      }
      if (trailing.length >= 2) {
        trailing.forEach(function (row) {
          cloneToSpecs(row);
          row.hidden = true;
        });
      }
    };

    extractTrailingLabelRows(descPanel);

    var lastDescDiv = null;
    for (var i = children.length - 1; i >= 0; i--) {
      var c = children[i];
      if (!c.hidden && c.tagName === "DIV" && !alreadyCaptured(c)) {
        lastDescDiv = c;
        break;
      }
    }
    if (lastDescDiv) extractTrailingLabelRows(lastDescDiv);

    if (added && emptyMsg) emptyMsg.hidden = true;

    /* Hide the Specifications tab button when no specs were found */
    var specsTabBtn = section.querySelector('[data-tab="specifications"]');
    if (specsTabBtn) {
      if (!added) {
        specsTabBtn.hidden = true;
        specsTabBtn.setAttribute("aria-hidden", "true");
        specsTabBtn.setAttribute("tabindex", "-1");
      } else {
        specsTabBtn.hidden = false;
        specsTabBtn.removeAttribute("aria-hidden");
        specsTabBtn.removeAttribute("tabindex");
      }
    }
  };

  /* ── Layout 1: Tech Magazine — alternating feature rows ─────────── */

  var buildTechMagazine = function (wrapper) {
    /* Pre-pass: expand "section-heading + sub-feature-container" divs
     * Handles: <div><h3>Section Title</h3><div><div>sub1</div>...</div></div>
     * where the inner container holds multiple sub-feature divs that each
     * need individual feature card treatment. */
    var expandSectionContainers = function () {
      var changed = false;
      Array.from(wrapper.children).forEach(function (child) {
        if (child.tagName !== "DIV" || child.hidden) return;
        var directChildren = Array.from(child.children);
        var directHds = directChildren.filter(function (c) {
          return /^H[1-6]$/.test(c.tagName);
        });
        var directPs = directChildren.filter(function (c) {
          return c.tagName === "P";
        });
        var directDivs = directChildren.filter(function (c) {
          return c.tagName === "DIV";
        });

        /* Case 1 — "section heading + one inner container" pattern:
         * <div><h3>Title</h3><div><div>sub1</div>...</div></div> */
        if (
          directHds.length === 1 &&
          directPs.length === 0 &&
          directDivs.length === 1
        ) {
          var innerContainer = directDivs[0];
          var hasSubFeatures = !!(
            innerContainer.querySelector("h2, h3, h4, h5, h6") ||
            innerContainer.querySelector("img")
          );
          if (hasSubFeatures) {
            var headingWrap = document.createElement("div");
            headingWrap.appendChild(directHds[0]);
            wrapper.insertBefore(headingWrap, child);
            while (innerContainer.firstChild) {
              wrapper.insertBefore(innerContainer.firstChild, child);
            }
            child.remove();
            changed = true;
            return;
          }
        }

        /* Case 2 — container div with no section heading of its own, but with
         * sub-divs that hold feature content. May also have a few intro paragraphs.
         * Inline everything so buildFeatureCard can reach sub-divs as direct children. */
        if (directHds.length === 0 && directDivs.length >= 1) {
          var hasSub = directDivs.some(function (d) {
            return (
              d.querySelector("h2, h3, h4, h5, h6") ||
              d.querySelector("p") ||
              d.querySelector("img")
            );
          });
          if (hasSub) {
            while (child.firstChild)
              wrapper.insertBefore(child.firstChild, child);
            child.remove();
            changed = true;
          }
        }
      });
      return changed;
    };
    var expandCount = 0;
    while (expandSectionContainers() && ++expandCount < 3) {}

    /* Merge a heading-only div with its immediately following content div.
     * Handles: <div><h2>Title<img></h2></div><div>[content rows]</div> */
    (function () {
      var kids = Array.from(wrapper.children);
      for (var i = 0; i < kids.length - 1; i++) {
        var curr = kids[i];
        var next = kids[i + 1];
        if (curr.tagName !== "DIV" || next.tagName !== "DIV") continue;
        if (curr.hidden || next.hidden) continue;
        var visible = Array.from(curr.children).filter(function (c) {
          return !c.hidden;
        });
        if (visible.length !== 1 || !/^H[1-6]$/.test(visible[0].tagName))
          continue;
        if (
          Array.from(next.children).some(function (c) {
            return /^H[1-6]$/.test(c.tagName);
          })
        )
          continue;
        while (next.firstChild) curr.appendChild(next.firstChild);
        next.remove();
        kids.splice(i + 1, 1);
      }
    })();

    Array.from(wrapper.children).forEach(function (child) {
      if (child.tagName !== "DIV" || child.hidden) return;
      if (isQuoteBlock(child)) {
        buildPullquote(child);
        return;
      }
      buildFeatureCard(child);
    });

    wrapper.querySelectorAll(":scope > blockquote").forEach(buildPullquote);
    wrapStandaloneMedia(wrapper);

    /* Alternate every second image-bearing card */
    wrapper
      .querySelectorAll(".product-feature:not(.product-feature--text)")
      .forEach(function (card, i) {
        if (i % 2 === 1) card.classList.add("product-feature--reverse");
      });

    /* Mark the last feature card so CSS can reliably remove its bottom divider */
    var allCards = Array.from(
      wrapper.querySelectorAll(":scope > .product-feature"),
    );
    if (allCards.length > 0)
      allCards[allCards.length - 1].classList.add("product-feature--last");

    /* Side-by-side embed + text-only feature block */
    var embed = wrapper.querySelector(":scope > .itg-embed-wrap");
    var featureText = wrapper.querySelector(":scope > .product-feature--text");

    /* Fallback: flat description with no headings — bundle loose paragraphs
     * with the embed so it renders as a featured media + text layout */
    if (embed && !featureText) {
      var looseParagraphs = Array.from(
        wrapper.querySelectorAll(":scope > p"),
      ).filter(function (p) {
        return !p.hidden && p.textContent.trim();
      });
      if (looseParagraphs.length) {
        var textBlock = document.createElement("div");
        textBlock.className = "product-feature product-feature--text";
        looseParagraphs.forEach(function (p) {
          textBlock.appendChild(p);
        });
        wrapper.appendChild(textBlock);
        featureText = textBlock;
      }
    }

    if (embed && featureText) {
      var newWrapper = document.createElement("div");
      newWrapper.className = "new-wrapper";
      wrapper.insertBefore(newWrapper, embed);
      newWrapper.appendChild(embed);
      newWrapper.appendChild(featureText);
    }

    /* Trim each media-card content column to 250 words and place any
     * remaining paragraphs in a full-width div below the card. */
    wrapper
      .querySelectorAll(":scope > .product-feature:not(.product-feature--text)")
      .forEach(function (card) {
        var col = card.querySelector(".product-feature__content");
        if (!col) return;
        var max = 250;
        var count = 0;
        var excess = [];
        Array.from(col.querySelectorAll(":scope > p")).forEach(function (p) {
          if (count >= max) {
            excess.push(p);
            return;
          }
          var pw = p.textContent.trim().split(/\s+/).filter(Boolean).length;
          if (count + pw > max) {
            var words = p.textContent.trim().split(/\s+/);
            var kept = words.slice(0, max - count).join(" ") + "…";
            var rest = words.slice(max - count).join(" ");
            p.textContent = kept;
            count = max;
            if (rest.trim()) {
              var rp = document.createElement("p");
              rp.textContent = rest;
              excess.push(rp);
            }
          } else {
            count += pw;
          }
        });
        if (excess.length) {
          var belowDiv = document.createElement("div");
          belowDiv.className = "product-feature__below-overflow";
          excess.forEach(function (p) {
            belowDiv.appendChild(p);
          });
          card.after(belowDiv);
        }
      });
  };

  /* ── Layout 2: Engineering Grid — vertical feature card grid ─────── */

  var buildEngineeringGrid = function (wrapper) {
    Array.from(wrapper.children).forEach(function (child) {
      if (child.tagName !== "DIV" || child.hidden) return;
      if (isQuoteBlock(child)) {
        buildPullquote(child);
        return;
      }
      buildFeatureCard(child);
    });

    wrapper.querySelectorAll(":scope > blockquote").forEach(buildPullquote);
    wrapStandaloneMedia(wrapper);

    /* Collect all feature cards and wrap them in a grid container */
    var cards = Array.from(
      wrapper.querySelectorAll(":scope > .product-feature"),
    );
    if (cards.length >= 2) {
      var grid = document.createElement("div");
      grid.className = "itg-feature-grid";
      wrapper.insertBefore(grid, cards[0]);
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
    }
  };

  /* ── Layout 3: Story Scroll — full-width cinematic image breaks ──── */

  var buildStoryScroll = function (wrapper) {
    Array.from(wrapper.children).forEach(function (child) {
      if (child.tagName !== "DIV" || child.hidden) return;
      if (isQuoteBlock(child)) {
        buildPullquote(child);
        return;
      }

      child.classList.add("itg-story-section");

      /* Promote images from <p> wrappers to full-width story breaks */
      Array.from(child.querySelectorAll(":scope > p")).forEach(function (p) {
        var img = p.querySelector("img");
        if (!img) return;
        var storyBreak = document.createElement("div");
        storyBreak.className = "itg-story-break";
        if (!p.textContent.trim()) {
          storyBreak.appendChild(img);
          p.replaceWith(storyBreak);
        } else {
          storyBreak.appendChild(img.cloneNode(true));
          child.insertBefore(storyBreak, p);
          img.remove();
        }
      });

      /* Promote direct child images */
      Array.from(child.querySelectorAll(":scope > img")).forEach(
        function (img) {
          var storyBreak = document.createElement("div");
          storyBreak.className = "itg-story-break";
          img.replaceWith(storyBreak);
          storyBreak.appendChild(img);
        },
      );

      /* Promote direct figures */
      Array.from(child.querySelectorAll(":scope > figure")).forEach(
        function (fig) {
          var storyBreak = document.createElement("div");
          storyBreak.className = "itg-story-break";
          fig.replaceWith(storyBreak);
          storyBreak.appendChild(fig);
        },
      );
    });

    wrapper.querySelectorAll(":scope > blockquote").forEach(buildPullquote);
    wrapStandaloneMedia(wrapper);
  };

  /* ── Shared cleanup + layout dispatch ───────────────────────────── */

  var cleanDescription = function (descPanel, layout) {
    layout = layout || "tech-magazine";
    var wrapper =
      descPanel.querySelector(".itg-tabs__product-desc") || descPanel;

    stripInlineStyles(wrapper);

    wrapper.querySelectorAll("p").forEach(function (p) {
      if (p.querySelector("img, video, iframe")) return;
      if (!p.textContent.replace(/[ \s]/g, "").length) p.remove();
    });

    wrapper.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(function (h) {
      if (h.textContent.trim()) return;
      var parent = h.parentElement;
      h.remove();
      if (
        parent &&
        parent !== wrapper &&
        parent !== descPanel &&
        !parent.textContent.trim() &&
        !parent.querySelector("img")
      ) {
        parent.remove();
      }
    });

    wrapper.querySelectorAll("h1").forEach(function (h1) {
      var h2 = document.createElement("h2");
      Array.from(h1.attributes).forEach(function (attr) {
        h2.setAttribute(attr.name, attr.value);
      });
      while (h1.firstChild) h2.appendChild(h1.firstChild);
      h1.replaceWith(h2);
    });

    /* Promote <p><strong>TEXT</strong></p> to <h2> so section grouping fires */
    wrapper.querySelectorAll(":scope > p").forEach(function (p) {
      if (p.children.length !== 1) return;
      var child = p.children[0];
      if (child.tagName !== "STRONG" && child.tagName !== "B") return;
      if (child.querySelector("img, video, iframe")) return;
      var text = child.textContent.trim();
      if (text !== p.textContent.trim() || text.length < 3 || text.length > 120)
        return;
      var h2 = document.createElement("h2");
      h2.textContent = text;
      p.replaceWith(h2);
    });

    groupFlatContent(wrapper);

    if (layout === "story-scroll") {
      buildStoryScroll(wrapper);
    } else if (layout === "engineering-grid") {
      buildEngineeringGrid(wrapper);
    } else {
      buildTechMagazine(wrapper);
    }
  };

  /* ── Tab switching ───────────────────────────────────────────────── */

  var initTabs = function (section) {
    var tabs = section.querySelectorAll(".itg-tabs__tab");
    var panels = section.querySelectorAll(".itg-tabs__panel");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.dataset.tab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle("is-active", active);
          t.setAttribute("aria-selected", String(active));
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.tabPanel === target;
          panel.classList.toggle("is-active", active);
          panel.hidden = !active;
        });
      });
    });
  };

  /* ── Bootstrap ───────────────────────────────────────────────────── */

  var init = function (section) {
    var isMeta = section.hasAttribute("data-itg-meta");
    if (!isMeta) {
      var layout = section.dataset.layout || "tech-magazine";
      var descPanel = section.querySelector('[data-tab-panel="description"]');
      if (descPanel) {
        try {
          cleanDescription(descPanel, layout);
        } catch (e) {
          console.warn("[itg-product-tabs] cleanDescription error:", e);
        }
      }
      try {
        syncSpecs(section);
      } catch (e) {
        // syncSpecs is non-critical
      }

      /* Hide the Description tab button if the panel has no visible content */
      var descTabBtn = section.querySelector('[data-tab="description"]');
      if (descPanel && descTabBtn) {
        var visibleContent = Array.from(
          descPanel.querySelectorAll(
            "p, h2, h3, h4, h5, h6, ul, ol, table, dl, img, iframe, video, blockquote, .product-feature, .itg-pullquote",
          ),
        ).some(function (el) {
          return (
            (!el.hidden && el.textContent.trim().length > 0) ||
            el.tagName === "IMG" ||
            el.tagName === "IFRAME" ||
            el.tagName === "VIDEO"
          );
        });
        if (!visibleContent) {
          descTabBtn.hidden = true;
          descTabBtn.setAttribute("aria-hidden", "true");
          descTabBtn.setAttribute("tabindex", "-1");
          /* Auto-activate the next visible tab */
          var firstVisible = section.querySelector(
            ".itg-tabs__tab:not([hidden])",
          );
          var firstPanel =
            firstVisible &&
            section.querySelector(
              '[data-tab-panel="' + firstVisible.dataset.tab + '"]',
            );
          if (firstVisible && firstPanel) {
            descPanel.classList.remove("is-active");
            descPanel.hidden = true;
            firstVisible.classList.add("is-active");
            firstVisible.setAttribute("aria-selected", "true");
            firstPanel.classList.add("is-active");
            firstPanel.hidden = false;
          }
        }
      }
    }
    initTabs(section);
  };

  document.querySelectorAll("[data-itg-product-tabs]").forEach(init);

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector("[data-itg-product-tabs]");
    if (section) init(section);
  });
})();
